import React from "react";
import LmsTable from "../ui/LmsTable";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";

const LmsSystemsLockedLoans = () => {
  const handleUnlockClick = () => {
    if (FeatureFlags.IS_DEBUG) {
      console.log("Unlock Clicked");
    }
  };

  const actionsButtons = ["export", { text: "Unlock", icon: GlobalConstants.Icons.CARET_UP, handleClick: handleUnlockClick }];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="" // TODO: Add loan comments suffix
    sortable={["Created On"]}
  />;
};

export default LmsSystemsLockedLoans;